import React, { useEffect, useState } from 'react';

import { vwSet } from './../../utils/helpers';

// import FilterBarMobile from './FilterBarMobile';
import FilterBarDesktop from './FilterBarDesktop';

const AgendaFilters = ({
  activeTab,
  activeSubSite,
  filteredCount,

  activeFilterDate,
  activeTimestamp,
  activeCinema,
  activeTags,
  sortingDecision,

  availableDates,
  availableDatesMonths,
  availableCinema,
  availableTags,

  filterDate,
  filterCinema,
  filterTags,
  resetFilters,
  sortByUser,

  currentConfig,
  rootElement,
}) => {
  const [showFilters, setShowFilters] = useState([]);

  const handleFilter = (type, value, onlyActivate) => {
    if (type === 'filterDate') {
      filterDate(value);
      rootElement.querySelector(`.js_react_filter .js-date-button`).setAttribute('aria-expanded', 'false');
    }
    if (type === 'filterCinema') filterCinema(value);
    if (type === 'filterTags') filterTags(value, onlyActivate);
    if (type === 'resetFilters') resetFilters();
  };

  const handleToggle = () => {
    if (sortingDecision === 'popularity') {
      sortByUser('times');
    } else if (sortingDecision === 'times') {
      sortByUser('popularity');
    }
  };

  useEffect(() => {
    vwSet();
    window.addEventListener('resize', vwSet);
    return () => {
      window.removeEventListener('resize', vwSet);
    };
  }, [vwSet]);

  useEffect(() => {
    //check which types of filters we need for this tab/cinema
    const filterTypes = [];
    if (activeTab === 'now' || activeTab === 'kids') {
      filterTypes.push('date');
    }
    if (currentConfig.has_cinema_selector && activeTab !== 'expected' && activeTab !== 'all' && activeSubSite === '') {
      filterTypes.push('cinema');
    }
    if (activeTab === 'now' || activeTab === 'all') {
      // availableTags.length >= 0 && filterTypes.push('tags');
    }
    setShowFilters(filterTypes);
  }, [activeTab]);

  if (showFilters.length <= 0) {
    return <></>;
  }

  return (
    <>
      {/* <FilterBarMobile
				filteredCount={filteredCount}
				activeFilterDate={activeFilterDate}
				activeTimestamp={activeTimestamp}
				activeCinema={activeCinema}
				activeTags={activeTags}
				sortingDecision={sortingDecision}
				availableDates={availableDates}
				availableCinema={availableCinema}
				availableTags={availableTags}
				currentConfig={currentConfig}
				showFilters={showFilters}
				handleToggle={handleToggle}
				handleFilter={handleFilter}
			/> */}
      <FilterBarDesktop
        activeFilterDate={activeFilterDate}
        activeTimestamp={activeTimestamp}
        activeCinema={activeCinema}
        activeTags={activeTags}
        sortingDecision={sortingDecision}
        availableDates={availableDates}
        availableDatesMonths={availableDatesMonths}
        availableCinema={availableCinema}
        availableTags={availableTags}
        currentConfig={currentConfig}
        showFilters={showFilters}
        handleToggle={handleToggle}
        handleFilter={handleFilter}
        rootElement={rootElement}
      />
    </>
  );
};

export default AgendaFilters;
